import styled from "styled-components";

const StyledAlert = styled.div`
  .alert-container {
    height: calc(var(--vh, 1vh) * 100);
    display: flex;
    flex-flow: column;
    justify-content: end;

    .alert {
      position: relative;
      top: 0;
      z-index: 1000;
      margin-bottom: 30px;
      pointer-events: auto;
    }
  }
`;

export default StyledAlert;
